'use client'
import React from 'react'

export default function Loading({ imageUrl }: { imageUrl: string }) {
  return (
    <div className="main-loader">
      <div className="text-loader">
        {/*eslint-disable-next-line*/}
				<img
          className="main-loader-image"
          src={imageUrl}
          alt="loading"
        />
      </div>
    </div>
  )
}
